<template>
  <div>
    <el-form ref="form" :model="form" label-width="30px">
      <el-form-item>
        <span slot="label">
          <b-icon class="icon-span" name="Username"></b-icon>
        </span>
        <el-input
          v-model="form.email"
          placeholder="Email"
          type="email"
          autocapitalize="off"
          autocorrect="off"
          prop="email"
          @keyup.enter.native="onLogin"
        />
      </el-form-item>
      <el-form-item prop="pass">
        <span slot="label">
          <b-icon class="icon-span" name="Password"></b-icon>
        </span>
        <el-input
          v-model="form.password"
          placeholder="Password"
          type="password"
          @keyup.enter.native="onLogin"
          :auto-complete="'off'"
        />
      </el-form-item>
    </el-form>
    <el-button type="primary" @click="onLogin">Login</el-button>
  </div>
</template>

<script>
export default {
  props: {
    isUpgrade: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: {
        email: '',
        password: ''
      }
    }
  },
  methods: {
    onLogin() {
      let f = this.form
      let authForm =
        'username=' +
        f.email +
        '&password=' +
        f.password +
        '&grant_type=password'
      if (this.isUpgrade) {
        this.$store.dispatch('upgrade', authForm)
      } else {
        this.$store.dispatch('login', authForm)
      }
    }
  }
}
</script>

<style scoped>
.icon-span {
  margin-bottom: -10px;
  padding-right: 50%;
}
</style>
